import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import {
  Spacer,
  Visible,
  BreakPointItem,
  BREAKPOINTS,
} from '@tfecom-thermofisher/react-komodo-design';

import messages from 'src/messages';
import withDnaData from 'src/components/OligoDNA/components/withDnaData';
import withDnaSteps from 'src/components/OligoDNA/components/withDnaSteps';
import { SectionTitle } from 'src/components';
import {
  FILE_NAMESPACE,
  PLATE_SIZE_DETAILS_NAMESPACE,
  NORMALIZATION_ALIQUOTS_NAMESPACE,
  PLATE_POOLING_NAMESPACE,
  COUNTRY_CODE_JAPAN
} from 'src/constants/forms';
import { DnaOligo } from 'src/models';

import {
  FileDetails,
  NormalizationAliquotsDetails,
  PlatePoolingDetails,
  PlateSizeDetails,
  SectionDivider,
} from './components';
import './Summary.style.scss';

const SummaryContainer = ({
  dnaData,
  dnaSteps,
  showTitle,
  showOrderSummaryTitle,
  onFileDetailsEdit,
  onPlateSizeDetailsEdit,
  onNormalizationAliquotsDetailsEdit,
  onPlatePoolingDetailsEdit,
  countryCode,
}) => (
  <>
    <Visible when={showOrderSummaryTitle}>
      <div>
        <SectionTitle title={messages.orderSummary} />
        <Spacer bottom={24} />
      </div>
    </Visible>
    <div className={showTitle ? 'summary-steps' : ''}>
      <div className={showTitle ? 'pairs' : ''}>
        <FileDetails
          file={dnaData[FILE_NAMESPACE] || {}}
          showTitle={showTitle}
          onEditClick={onFileDetailsEdit}
        />
        <Visible when={dnaSteps[1]?.isVisited}>
          <SectionDivider />
          <PlateSizeDetails
            details={dnaData[PLATE_SIZE_DETAILS_NAMESPACE] || {}}
            showTitle={showTitle}
            onEditClick={onPlateSizeDetailsEdit}
            dnaType={DnaOligo.getDNAType()}
          />
          <BreakPointItem max={BREAKPOINTS.md} includeMax>
            <SectionDivider />
          </BreakPointItem>
        </Visible>
      </div>
      <Visible when={dnaSteps[1]?.isVisited}>
        <BreakPointItem min={BREAKPOINTS.md}>
          <SectionDivider />
        </BreakPointItem>
      </Visible>
      <div className={showTitle ? 'pairs' : ''}>
        <Visible when={dnaSteps[2]?.isVisited && (
          DnaOligo.getDNAType() !== null || countryCode !== COUNTRY_CODE_JAPAN
        )}
        >
          <NormalizationAliquotsDetails
            details={dnaData[NORMALIZATION_ALIQUOTS_NAMESPACE] || {}}
            showTitle={showTitle}
            onEditClick={onNormalizationAliquotsDetailsEdit}
          />

        </Visible>
        <Visible when={dnaSteps[3]?.isVisited && (
          DnaOligo.getDNAType() !== null || countryCode !== COUNTRY_CODE_JAPAN
        )}
        >
          <SectionDivider />
          <PlatePoolingDetails
            details={dnaData[PLATE_POOLING_NAMESPACE] || {}}
            showTitle={showTitle}
            onEditClick={onPlatePoolingDetailsEdit}
          />
        </Visible>
      </div>
    </div>
  </>
);

SummaryContainer.propTypes = {
  dnaData: PropTypes.object.isRequired,
  dnaSteps: PropTypes.array.isRequired,
  showTitle: PropTypes.bool,
  showOrderSummaryTitle: PropTypes.bool,
  onFileDetailsEdit: PropTypes.func,
  onPlateSizeDetailsEdit: PropTypes.func,
  onNormalizationAliquotsDetailsEdit: PropTypes.func,
  onPlatePoolingDetailsEdit: PropTypes.func,
  countryCode: PropTypes.string
};

export default compose(withDnaData, withDnaSteps)(SummaryContainer);
